import React, {useEffect, useRef} from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import {Paragraph} from "@arctheme-components/elements/Paragraph/Paragraph";
import {Headings} from "@arctheme-components/elements/Headings/Headings";
import Tile from "@project-stories/elements/Tile/Tile";

export default function Carousel({
    settings,
    columns,
    headerText,
    subtext,
    tagline,
    columns_count,
}) {
    const { section } = settings;
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    const isFirstColumnDefaultLayout = columns[0]?.settings.layout === "default";
    let firstBlockHeight = isMobile
        ? columns[0]?.settings.mobile_block_height
        : columns[0]?.settings.block_height;

    if (!isFirstColumnDefaultLayout) {
        firstBlockHeight = 0;
    }
    const gapBetweenBlocksX = isMobile
        ? settings.section.gap_mobile
        : settings.section.gap;
    const gapBetweenBlocksY = isMobile
        ? settings.section.gap_y_mobile
        : settings.section.gap_y;

    const titleStyle = isMobile
        ? settings.section.header_style_mobile
        : settings.section.header_style;

    const taglineStyle = isMobile
        ? settings.section.tagline_style_mobile
        : settings.section.tagline_style;

    const contentStyle = isMobile
        ? settings.section.subtext_style_mobile
        : settings.section.subtext_style;

    const layoutType = isMobile
        ? settings.section.layout_mobile
        : settings.section.layout;

    settings.show_indicators = section.show_indicators;
    settings.show_navbuttons = section.show_navbuttons;
    settings.use_freescroll = section.use_freescroll;
    settings.fade_edgeitems = section.fade_edgeitems;

    return (
        <div className={`multicolumn-${layoutType}`}>
            {(tagline || headerText || subtext) && (
                <div className="multicolumn-content-top">
                    {tagline && <Paragraph text={tagline} type={taglineStyle}/>}
                    {headerText && <Headings text={headerText} type={titleStyle}/>}
                    {subtext && <Paragraph text={subtext} type={contentStyle} maxChars={settings.section.max_characters_subtext}/>}
                </div>
            )}

            <div className="multicolumn-carousel carousel"
                 data-flickity={`{` +
                     `"freeScroll": ${settings.use_freescroll}, ` +
                     `"wrapAround": true, ` +
                     `"cellAlign": "left", ` +
                     `"pageDots": ${settings.show_indicators}, ` +
                     `"prevNextButtons": ${settings.show_navbuttons}, ` +
                     `"groupCells": 1` +
                 `}`}
                 {...({
                     "x-data": "carousel",
                     "x-init": `$nextTick(() => { initialise(${settings.show_indicators}, ${settings.show_navbuttons}, ${settings.fade_edgeitems}, false, 0, 'multicolumn-carousel', true, ${settings.use_freescroll}) })`,
                     "x-ref": "carousel",
                 })}
            >
                {columns.map((column, index) => {
                    const columnWidth = isMobile
                        ? column.settings.width_mobile
                        : column.settings.width;
                    const defaultFlexBasis = `${100 / columns_count}%`;
                    const flexBasis =
                        columnWidth > 0
                            ? `calc(${columnWidth}% - ${gapBetweenBlocksX}px)`
                            : `calc(${defaultFlexBasis} - ${gapBetweenBlocksX}px)`;
                    const columnHeight = isMobile
                        ? column.settings.mobile_block_height
                        : column.settings.block_height;
                    const heightStyle = columnHeight > 0 ? `${columnHeight}px` : "auto";

                    return (
                        <div
                            key={column.key || index}
                            style={{
                                flexBasis,
                                marginTop: `${gapBetweenBlocksY / 2}px`,
                                marginBottom: `${gapBetweenBlocksY / 2}px`,
                                marginLeft: `${gapBetweenBlocksX / 2}px`,
                                marginRight: `${gapBetweenBlocksX / 2}px`,
                                maxWidth: `${isMobile ? settings.section.visible_slide_width_mobile : 100}%`
                            }}
                            className={`carousel-cell`}
                        >
                            <Tile
                                data={column}
                                layout={column.settings.layout}
                                height={heightStyle}
                                settings={settings}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
